import { useQuery } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { fetchUserOrganizationsCount, fetchUserSourcesCount, } from "../api/usersService";
export var useUserData = function (userId) {
    var ky = useOkapiKy();
    var _a = useQuery(["userOrganizationsCount", userId], function () { return fetchUserOrganizationsCount(ky, userId); }, {
        enabled: !!userId,
    }), userOrganizationsCount = _a.data, isOrganizationsCountLoading = _a.isLoading, isOrganizationsCountError = _a.isError, organizationsCountError = _a.error;
    var _b = useQuery(["userSourcesCount", userId], function () { return fetchUserSourcesCount(ky, userId); }, {
        enabled: !!userId,
    }), userSourcesCount = _b.data, isSourcesCountLoading = _b.isLoading, isSourcesCountError = _b.isError, sourcesCountError = _b.error;
    return {
        countsLoading: isOrganizationsCountLoading || isSourcesCountLoading,
        canEditEmail: (userOrganizationsCount !== null && userOrganizationsCount !== void 0 ? userOrganizationsCount : 0) <= 1 && (userSourcesCount !== null && userSourcesCount !== void 0 ? userSourcesCount : 0) <= 1,
        isCountsError: isOrganizationsCountError || isSourcesCountError,
        organizationsCountError: organizationsCountError,
        sourcesCountError: sourcesCountError,
    };
};
